import { Box } from '@mui/material';
import React from 'react';
import { func, string } from 'prop-types';
import SearchField from 'components/controls/SearchField';

const rootSx = {
  minWidth: 250,
  display: 'flex',
  alignItems: 'center',
};

const Search = rawProps => {
  const props = { value: '', ...rawProps };
  const { value, onChange } = props;
  return (
    <Box sx={rootSx}>
      <SearchField value={value} onChange={onChange} />
    </Box>
  );
};

Search.propTypes = {
  value: string,
  onChange: func.isRequired,
};

export default Search;
